/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { CoreModule } from './@core/core.module';
import { ThemeModule } from './@theme/theme.module';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import {
  NbChatModule,
  NbDatepickerModule,
  NbTimepickerModule,
  NbDialogModule,
  NbMenuModule,
  NbSidebarModule,
  NbToastrModule,
  NbWindowModule,
  NbToggleModule,
  NbCardModule,
  NbTabsetModule,
  NbButtonModule,
  NbProgressBarModule,
  NbIconModule,
  NbCheckboxModule,
  NbInputModule,

} from '@nebular/theme';
import { AuthGuard } from './auth-guard.service';
import { NbTokenLocalStorage } from '@nebular/auth';
import { NbEvaIconsModule } from '@nebular/eva-icons';
import { DatePipe } from '@angular/common';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ConfirmPasswordComponent } from './confirm-password/confirm-password.component';
import { ConfirmComponent } from './confirm/confirm.component';
import { AgmCoreModule } from '@agm/core';
import { FileuploadComponent } from './fileupload/fileupload.component';
import { ExcelImportComponent } from './general/excel-import/excel-import.component';
import { Ng2SmartTableModule } from 'ng2-smart-table';
import { ObjectEditComponent } from './general/object-edit/object-edit.component';
import { FileViewerComponent } from './file-viewer/file-viewer.component';
import { EmailIdComponent } from './general/email-id/email-id.component';
import { WeekdayPickerComponent } from './general/weekday-picker/weekday-picker.component';
import { AvailabilityFormComponent } from './general/availability-form/availability-form.component';
import { AvailabilityInfoComponent } from './general/availability-info/availability-info.component';

@NgModule({
  declarations: [AppComponent, ConfirmPasswordComponent, ConfirmComponent, FileuploadComponent, ExcelImportComponent, ObjectEditComponent, FileViewerComponent, EmailIdComponent, WeekdayPickerComponent, AvailabilityFormComponent, AvailabilityInfoComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    NbToggleModule,
    NbTabsetModule,
    NbButtonModule,
    NbProgressBarModule,
    Ng2SmartTableModule,
    NbIconModule,
    NbInputModule,
    FormsModule,
    NbSidebarModule.forRoot(),
    NbMenuModule.forRoot(),
    NbDatepickerModule.forRoot(),
    NbTimepickerModule.forRoot(),
    NbDialogModule.forRoot(),
    NbWindowModule.forRoot(),
    NbToastrModule.forRoot(),
    NbChatModule.forRoot({
      messageGoogleMapKey: 'AIzaSyA_wNuCzia92MAmdLRzmqitRGvCF7wCZPY',
    }),
    CoreModule.forRoot(),
    ThemeModule.forRoot(),
    NbEvaIconsModule,
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
    ReactiveFormsModule,
    NbCardModule,
    NbCheckboxModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyAwd50TBAzq91RgL8MXy2zQwbvx0fn9dO4',
      libraries: ['places']
    })

  ],
  providers: [
    AuthGuard,
    NbTokenLocalStorage,
    DatePipe,

  ],
  bootstrap: [AppComponent],

})
export class AppModule {
}
